import React, { ComponentPropsWithoutRef, PropsWithChildren } from 'react';
import RecommendedProductItem from './RecommendedProductItem';
import classnames from 'classnames';
import { ProductInterface } from '../../../../../../services/exports/Interfaces';
import useAppMethods from '../../../../../../hooks/utility/useAppMethods';
import useMobileApp from '../../../../../../hooks/mobile-app/useMobileApp';
import useModalRouter from '../../../../common/hooks/useModalRouter';
import { Modals } from '../../../../exports/Enums';

type RecommendedProductsProps = ComponentPropsWithoutRef<'section'> & PropsWithChildren;

const RecommendedProducts = ({ className, children, ...rest }: RecommendedProductsProps) => {
  return (
    <section className={classnames('space-y-md', className)} {...rest}>
      {children}
    </section>
  );
};

type ContentProps = ComponentPropsWithoutRef<'div'> & { products: ProductInterface[] };

RecommendedProducts.Content = ({ className, products, ...rest }: ContentProps) => {
  const { toggleMenuItemModal } = useAppMethods();
  const { isMobileApp } = useMobileApp();
  const { openModal, closeModal } = useModalRouter();

  const onProductClick = (product: ProductInterface) => {
    if (isMobileApp) {
      return openModal({
        id: Modals.MenuItem,
        presentation: {
          initialBreakpoint: 1,
          breakpoints: [0, 1],
          handle: false,
        },
        props: {
          openModal: true,
          product: product,
          isFreeItem: product.discount === 100,
          onCloseModal: closeModal,
        },
      });
    }

    toggleMenuItemModal({
      openModal: true,
      product: product,
    });
  };
  return (
    <div
      className={classnames(
        'space-x-md flex h-[88px] overflow-x-scroll scrollbar-hide snap-x snap-mandatory',
        className,
      )}
      {...rest}
    >
      {products.map((product) => (
        <RecommendedProductItem key={product.id} product={product} onClick={() => onProductClick(product)} />
      ))}
    </div>
  );
};

type HeaderProps = ComponentPropsWithoutRef<'h2'> & { title: string };

RecommendedProducts.Header = ({ title, className, ...rest }: HeaderProps) => {
  return (
    <h2 className={classnames('text-md font-semibold', className)} {...rest}>
      {title}
    </h2>
  );
};

export default RecommendedProducts;
